import styled, { css } from "styled-components";
import { Button } from "@chakra-ui/react";

export const SolidButton = styled(Button)`
  ${({ theme }) => css`
  display: flex;
    background: transparent;
    border-radius: 30px;
    border: 2px solid ${theme.colors.main};
    color: ${theme.colors.main};
    padding: 0.8em 1.5em; 
    background: ${theme.colors.main};
    color: ${theme.colors.grey};
  `}
`;